export enum RateMode {
  SINGLE_RATE = 'SINGLE_RATE',
  MULTI_RATE = 'MULTI_RATE',
}

export const RATE_MODE_LABELS = [
  { mode: RateMode.MULTI_RATE, label: 'BAR + Staycation Rate' },
  { mode: RateMode.SINGLE_RATE, label: 'BAR' },
] as const;
